module.exports = __webpack_public_path__ + "static/img/fs.b2ee464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fs.png
// module id = O7QB
// module chunks = 1